module.exports = __webpack_public_path__ + "media/images/meta/rowhouse/apple-touch-icon-56e52894a7f2388e8387bf15b2d4a207.png";